import { colors } from '../../constants/colors';

const mobileButtonStyles ={
  fontWeight: 600,
  fontSize: '0.875rem',
  color: colors.primary,
};

export default mobileButtonStyles;